import { safeParse } from "@/utils/safeParse";
import reporter from "../report/reporter";
import { getPage, getSearch } from "../shared/global";
import { getAttribute } from "./get";
/**
 * 曝光数据获取
 * @param {Element} targetNode
 */
export function button_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 39008,
    event_name: "button_click",
    button_name: targetNode.getAttribute("data-button-name"),
    pin_id: getAttribute(targetNode, "data-content-id"),
    board_id: getAttribute(targetNode, "data-board-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;

  var source =
    getAttribute(targetNode, "data-content-source") ||
    getAttribute(targetNode, "data-dialog-title");

  if (source) {
    trackData.button_source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.button_source = sub_page_nm
      ? `${page_nm}_${sub_page_nm}`
      : page_nm;
  }

  if (page_nm === "搜索结果页") {
    trackData.filter_ids = getSearch().filter_ids || [];
  }

  const material_id = getAttribute(targetNode, "data-material-id");

  if (material_id) {
    trackData.content_id = material_id;
  }

  const file_id = getAttribute(targetNode, "data-file-id");
  if (file_id) {
    trackData.file_id = file_id;
  }

  const content_type = getAttribute(targetNode, "data-content-type");
  if (content_type) {
    trackData.content_type = content_type;
  }

  const report_type = getAttribute(targetNode, "data-report-type");
  if (report_type) {
    trackData.report_type = report_type;
  }

  const report_reason = getAttribute(targetNode, "data-report-reason");
  if (report_reason) {
    trackData.report_reason = report_reason;
  }

  const report_user_id = getAttribute(targetNode, "data-report-user-id");
  if (report_user_id) {
    trackData.report_user_id = report_user_id;
  }

  const report_pin_id = getAttribute(targetNode, "data-report-pin-id");
  if (report_pin_id) {
    trackData.report_pin_id = report_pin_id;
  }

  const report_content_id = getAttribute(targetNode, "data-report-content-id");
  if (report_content_id) {
    trackData.report_content_id = report_content_id;
  }

  const is_tag = getAttribute(targetNode, "data-is-tag");
  if (is_tag) {
    trackData.is_tag = +is_tag;
  }

  const report_domain_id = getAttribute(targetNode, "data-report-domain-id");
  if (report_domain_id) {
    trackData.report_domain_id = report_domain_id;
  }

  const concern_object_type = getAttribute(
    targetNode,
    "data-concern-object-type"
  );
  if (concern_object_type) {
    trackData.concern_object_type = concern_object_type;
  }

  const concern_object_id = getAttribute(targetNode, "data-concern-object-id");
  if (concern_object_id) {
    trackData.concern_object_id = concern_object_id;
  }

  const concern_object_name = getAttribute(
    targetNode,
    "data-concern-object-name"
  );
  if (concern_object_name) {
    trackData.concern_object_name = concern_object_name;
  }

  const ext = getAttribute(targetNode, "data-ext");
  if (ext) {
    Object.assign(trackData, safeParse(ext));
  }
  if (["关注页", "个人关注页", "新人引导页"].includes(page_nm)) {
    const dist_code = getAttribute(targetNode, "data-dist-code");
    if (dist_code) {
      trackData.dist_code = dist_code;
    }
  }

  // 空值不上报
  if (!trackData?.pin_id) {
    delete trackData?.pin_id;
  }
  if (!trackData?.board_id) {
    delete trackData?.board_id;
  }

  reporter(trackData);
}
